import { render, staticRenderFns } from "./HomeProfile.vue?vue&type=template&id=f227ed34&scoped=true&"
import script from "./HomeProfile.vue?vue&type=script&lang=ts&"
export * from "./HomeProfile.vue?vue&type=script&lang=ts&"
import style0 from "./HomeProfile.vue?vue&type=style&index=0&id=f227ed34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f227ed34",
  null
  
)

export default component.exports